import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { SubscriptionStatsReport } from '../types'

type SubscriptionStatsReportSelector = (state: ReduxState) => SubscriptionStatsReport | void

const getSubscriptionStatsReportSelector = (state: ReduxState) => state.reports.subscriptionStatsReport

export const subscriptionStatsReportSelector: SubscriptionStatsReportSelector = createSelector(getSubscriptionStatsReportSelector, subscriptionStats => subscriptionStats)
